import React, { Component } from "react";
import {
  DataGrid,
  Column,
  Paging,
  Pager,
  FormItem,
  Editing,
  FilterRow,
} from "devextreme-react/data-grid";
import uiInfo from "../../../ui-info";
import PaginaToolbar from "../../../components/PaginaToolbar";
import { criarParametrosLivroDiat } from "../../../DataSources";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";

const localStorageKey = "cadastroParametrosLivroDiatGridState";

export default class ParametrosLivroBox extends Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.state = {
      filtroCorrente: [],
      filtro: {},
    };
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this.criarParametrosLivroDiat = criarParametrosLivroDiat();
  }

  filtrar(e) {
    let filtro = this.state.filtro;

    let filtroCorrente = [];

    if (filtro.codigo !== undefined && filtro.codigo !== "") {
      filtroCorrente.push(["codigo", "=", filtro.codigo.trim()]);
    }
    if (filtro.numero !== undefined && filtro.numero !== "") {
      filtroCorrente.push(["numero", "=", filtro.numero.trim()]);
    }
    if (filtro.titulo !== undefined && filtro.titulo !== "") {
      filtroCorrente.push(["titulo", "contains", filtro.titulo.trim()]);
    }

    this._gridInstance.instance.filter(
      filtroCorrente.length > 0 ? filtroCorrente : null
    );
  }

  limparFiltro(e) {
    this.setState({ filtro: {}, _uiNome: "" });
    this.filtrar();
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("parametros_livro_diat/editar/" + e.data.id);
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form onSubmit={this.filtrar}>
            <Form
              id="frmPesquisa"
              formData={this.state.filtro}
              colCount={8}
              labelLocation={"top"}
            >
              <SimpleItem dataField="codigo" colSpan={2}>
                <Label text="Código" />
              </SimpleItem>
              <SimpleItem dataField="numero" colSpan={2}>
                <Label text="Número" />
              </SimpleItem>
              <SimpleItem dataField="titulo" colSpan={4}>
                <Label text="Título" />
              </SimpleItem>
            </Form>
            <br />
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Filtrar"
                  type="success"
                  onClick={this.filtrar}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Limpar Filtro" onClick={this.limparFiltro} />
              </div>
            </div>
          </form>
          <br />
          <PaginaToolbar
            titulo="Cadastro de Parâmetros Livro da Dívida Ativa"
            novoCb={this.novoRegistro.bind(this)}
          >
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={this.criarParametrosLivroDiat}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              filterSyncEnabled={true}
              wordWrapEnabled={true}
              onEditingStart={this.onAtualizandoRow}
            >
              <FilterRow visible={false} />
              <Editing allowDeleting={true} allowUpdating={true} useIcons={true} />
              <Column
                dataField={"prefeituraId"}
                caption={"Prefeitura"}
                visible={false}
              >
                <FormItem visible={false}></FormItem>
              </Column>
              <Column dataField={"codigo"} caption={"Código"} />
              <Column dataField={"numero"} caption={"Número"} />
              <Column dataField={"titulo"} caption={"Título"} />
              <Column dataField={"fundamento"} caption={"Fundamento"} />
              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  novoRegistro() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("/parametros_livro_diat/novo");
  }
}
